import {
  ConfirmVerificationRequest,
  ConfirmVerificationResponse,
  IdentityVerificationConfigResponse
} from "../types/identityVerification";
import { apiClient } from "./api";

export const identityVerificationService = {
  /**
   * 본인인증 설정 조회
   * SDK 방식에서는 storeId만 조회
   */
  async getConfig(): Promise<IdentityVerificationConfigResponse> {
    const response = await apiClient.get<IdentityVerificationConfigResponse>(
      "/identity-verification/config"
    );
    return response.data;
  },

  /**
   * 본인인증 결과 확인
   */
  async confirmVerification(
    request: ConfirmVerificationRequest
  ): Promise<ConfirmVerificationResponse> {
    const response = await apiClient.post<ConfirmVerificationResponse>(
      "/identity-verification/confirm",
      request
    );
    return response.data;
  },

};
